export default function calculateTimeDifference(previousDate: Date, t?: (key: string, options?: any) => string) {
  const currentDate = new Date();
  const timeDifference = currentDate.valueOf() - new Date(previousDate).valueOf();
  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);

  if (t) {
    if (years > 0) {
      return t("years_ago", { count: years, defaultValue: `${years} year${years > 1 ? "s" : ""} ago` });
    } else if (months > 0) {
      return t("months_ago", { count: months, defaultValue: `${months} month${months > 1 ? "s" : ""} ago` });
    } else if (days > 0) {
      return t("days_ago", { count: days, defaultValue: `${days} day${days > 1 ? "s" : ""} ago` });
    } else if (hours > 0) {
      return t("hours_ago", { count: hours, defaultValue: `${hours} hour${hours > 1 ? "s" : ""} ago` });
    } else if (minutes > 0) {
      return t("minutes_ago", { count: minutes, defaultValue: `${minutes} minute${minutes > 1 ? "s" : ""} ago` });
    } else {
      return t("just_now", { defaultValue: "Just now" });
    }
  }

  if (years > 0) {
    return `${years} year${years > 1 ? "s" : ""} ago`;
  } else if (months > 0) {
    return `${months} month${months > 1 ? "s" : ""} ago`;
  } else if (days > 0) {
    return `${days} day${days > 1 ? "s" : ""} ago`;
  } else if (hours > 0) {
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  } else if (minutes > 0) {
    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  } else {
    return "Just now";
  }
}
